import type { CanDeactivateFn } from '@angular/router';

// type-only, so the route table never pulls the lazy page into the main bundle
import type { AdminConfigs } from './admin-configs';

export const uiConfigLeaveGuard: CanDeactivateFn<AdminConfigs> = (page) => page.confirmLeave();
